module.exports = __webpack_public_path__ + "img/bindwx.e31fb5a2.png";